(() => {
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');

  window.Varellea.register('product-page', root => {
    const listener = new AbortController();
    const gallery = root.querySelector('[data-gallery]');
    const mediaList = root.querySelector('[data-media-list]');
    const buyBlock = root.querySelector('[data-buy-block]');
    const sticky = root.querySelector('[data-sticky-cart]');
    let variantRequest, recommendationRequest, observer;
    let lastModalTrigger;

    function mediaTarget(id) { return [...root.querySelectorAll('[data-media-id]')].find(item => item.dataset.mediaId === String(id)); }
    function setSafeProductBackTarget() {
      const link = root.querySelector('[data-product-back][data-collection-context="false"]');
      if (!link || !document.referrer) return;
      try {
        const previousPage = new URL(document.referrer);
        const currentPage = new URL(location.href);
        if (previousPage.origin === currentPage.origin && (previousPage.pathname !== currentPage.pathname || previousPage.search !== currentPage.search)) {
          link.href = previousPage.href;
        }
      } catch (_) {}
    }
    function showMedia(id) {
      const target = mediaTarget(id);
      if (!target || !mediaList) return;
      mediaList.scrollTo({ left: target.offsetLeft - mediaList.offsetLeft, behavior: reduceMotion.matches ? 'instant' : 'smooth' });
      root.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-current', String(button.dataset.mediaTarget === String(id))));
      for (const media of root.querySelectorAll('[data-media-id]')) if (media !== target) media.querySelectorAll('video').forEach(video => video.pause());
    }
    async function selectOptions(position) {
      const ids = [...root.querySelectorAll('[data-option-position]')].map(fieldset => fieldset.querySelector('[data-product-option]:checked')?.value || fieldset.querySelector('select[data-product-option]')?.value).filter(Boolean);
      const url = new URL(root.dataset.productUrl, location.origin);
      url.searchParams.set('option_values', ids.join(','));
      url.searchParams.set('section_id', root.dataset.sectionId);
      variantRequest?.abort();
      variantRequest = new AbortController();
      root.setAttribute('aria-busy', 'true');
      root.querySelectorAll('[data-buy-button], [data-sticky-buy]').forEach(button => button.disabled = true);
      try {
        const response = await fetch(url, { signal: variantRequest.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Variant section unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = doc.querySelector('[data-product-section]');
        if (!replacement) throw new Error('Variant section unavailable');
        const quantity = root.querySelector('[name="quantity"]')?.value;
        if (quantity) replacement.querySelector('[name="quantity"]')?.setAttribute('value', quantity);
        const selectedId = replacement.querySelector('[data-variant-id]')?.value;
        const browserUrl = new URL(root.dataset.productUrl, location.origin);
        if (selectedId) browserUrl.searchParams.set('variant', selectedId);
        else browserUrl.searchParams.set('option_values', ids.join(','));
        history.replaceState(history.state, '', browserUrl);
        window.Varellea.unmount(root);
        root.replaceWith(replacement);
        window.Varellea.mount(replacement);
        const focusTarget = replacement.querySelector(`[data-option-position="${position}"] [data-product-option]:checked`) || replacement.querySelector(`[data-option-position="${position}"] select`);
        focusTarget?.focus({ preventScroll: true });
      } catch (error) {
        if (error.name !== 'AbortError') {
          url.searchParams.delete('section_id');
          location.assign(url.toString());
        }
      } finally { root.removeAttribute('aria-busy'); }
    }
    async function addToCart(form) {
      const button = form.querySelector('[data-buy-button]');
      const feedback = form.querySelector('[data-product-feedback]');
      button.disabled = true;
      feedback.textContent = '';
      try {
        await window.VarelleaCart.add(form);
        feedback.textContent = root.dataset.addedLabel;
        await window.VarelleaCart.refresh(root.dataset.cartCountLabel, { source: 'add', openDrawer: true });
      } catch (error) {
        feedback.textContent = error.message || root.dataset.errorLabel;
      } finally { button.disabled = false; }
    }
    async function loadComplementary() {
      const host = root.querySelector('[data-product-recommendations]');
      if (!host) return;
      recommendationRequest = new AbortController();
      const url = new URL(host.dataset.url, location.origin);
      url.searchParams.set('section_id', host.dataset.sectionId);
      url.searchParams.set('product_id', host.dataset.productId);
      url.searchParams.set('limit', host.dataset.limit || '3');
      url.searchParams.set('intent', 'complementary');
      try {
        const response = await fetch(url, { signal: recommendationRequest.signal });
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = doc.querySelector('[data-product-recommendations]');
        if (incoming && !recommendationRequest.signal.aborted) {
          host.replaceChildren(...incoming.children);
          window.Varellea.mount(host);
        }
      } catch (_) {}
    }
    const onChange = event => {
      const option = event.target.closest('[data-product-option]');
      if (!option || !root.contains(option)) return;
      const fieldset = option.closest('[data-option-position]');
      const name = fieldset.querySelector('[data-option-name]');
      if (name) name.textContent = option.tagName === 'SELECT' ? option.selectedOptions[0].textContent : option.nextElementSibling?.dataset.optionValueName || option.nextElementSibling?.textContent || '';
      selectOptions(fieldset.dataset.optionPosition);
    };
    const onClick = event => {
      const thumb = event.target.closest('[data-media-target]');
      if (thumb) { showMedia(thumb.dataset.mediaTarget); return; }
      const galleryButton = event.target.closest('[data-gallery-prev], [data-gallery-next]');
      if (galleryButton) {
        const items = [...root.querySelectorAll('[data-media-id]')];
        const current = items.reduce((best, item, i) => Math.abs(item.getBoundingClientRect().left - mediaList.getBoundingClientRect().left) < Math.abs(items[best].getBoundingClientRect().left - mediaList.getBoundingClientRect().left) ? i : best, 0);
        showMedia(items[(current + (galleryButton.hasAttribute('data-gallery-next') ? 1 : -1) + items.length) % items.length]?.dataset.mediaId);
        return;
      }
      const zoom = event.target.closest('[data-zoom]');
      if (zoom) {
        const dialog = root.querySelector('[data-zoom-dialog]');
        const image = dialog?.querySelector('[data-zoom-image]');
        if (image) { image.src = zoom.dataset.zoom; image.alt = zoom.dataset.zoomAlt; lastModalTrigger = zoom; dialog.showModal(); }
        return;
      }
      const open = event.target.closest('[data-open-modal]');
      if (open) { const dialog = root.querySelector(`[id="${CSS.escape(open.dataset.openModal)}"]`); if (dialog) { lastModalTrigger = open; dialog.showModal(); } return; }
      const close = event.target.closest('[data-close-modal]');
      if (close) { close.closest('dialog')?.close(); return; }
      if (event.target.matches('dialog')) event.target.close();
      if (event.target.closest('[data-sticky-buy]')) {
        const form = root.querySelector('.v-product__form');
        if (form) form.requestSubmit(); else buyBlock?.scrollIntoView({ behavior: reduceMotion.matches ? 'instant' : 'smooth' });
      }
    };
    const onSubmit = event => { const form = event.target.closest('.v-product__form'); if (form && root.contains(form)) { event.preventDefault(); addToCart(form); } };
    const onBlockSelect = event => { const details = event.target.closest('details'); if (details) details.open = true; event.target.scrollIntoView({ block: 'center', behavior: 'instant' }); };
    const onDialogClose = () => lastModalTrigger?.focus();
    return {
      connect() {
        setSafeProductBackTarget();
        root.addEventListener('change', onChange, { signal: listener.signal });
        root.addEventListener('click', onClick, { signal: listener.signal });
        root.addEventListener('submit', onSubmit, { signal: listener.signal });
        root.addEventListener('varellea:block:select', onBlockSelect, { signal: listener.signal });
        root.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('close', onDialogClose, { signal: listener.signal }));
        if (sticky) {
          sticky.hidden = true;
          if (buyBlock && 'IntersectionObserver' in window) {
            observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, { threshold: 0 });
            observer.observe(buyBlock);
          }
        }
        const selectedMediaId = root.querySelector('[aria-current="true"][data-media-target]')?.dataset.mediaTarget;
        if (selectedMediaId) requestAnimationFrame(() => showMedia(selectedMediaId));
        loadComplementary();
      },
      disconnect() { listener.abort(); variantRequest?.abort(); recommendationRequest?.abort(); observer?.disconnect(); }
    };
  });
})();
